import { AppRoutingConstants } from "../app-routing.constants";
export class SearchApplicationsRoutingConstants {
    static SEARCH_APPLICATIONS_ROUTE = AppRoutingConstants.createRouteToView("search-applications");
    static FILTERED_SEARCH_APPLICATIONS_ROUTE = AppRoutingConstants.createRouteToView("search");
}
